import { Box, styled } from '@mui/material';

const AddressWrapper = styled(Box)`
  display: flex;
  align-items: center;
  direction: row;
  gap: 6px;
  position: relative;
`;

export default AddressWrapper;
